/**
 * String lookup for the media components.
 *
 * <p>The same rule as `message()` in `src/lib/messages.ts` — a missing key comes back as the key,
 * `{name}` is substituted — but without importing that module, which pulls every language's
 * catalogue into whatever imports it. The client components here are handed only the `media.*`
 * strings (`messagesWithPrefix`) and look them up with this.
 */
export type Labels = Record<string, string>;

export function label(
  labels: Labels,
  key: string,
  params: Record<string, string | number> = {},
): string {
  const template = labels[key];
  if (template == null) return key;
  return template.replace(/\{(\w+)\}/g, (whole, name: string) =>
    name in params ? String(params[name]) : whole,
  );
}
